import deviceDetector from 'mobile-device-detect'

export default () => {
  const isMobile = deviceDetector.isMobile
  const urlParams = new URLSearchParams(window.location.search)
  let subdomainSlug = ''
  if (urlParams.has('subdomain_slug')) {
    subdomainSlug = urlParams.get('subdomain_slug') + '.'
  }
  const query = `${subdomainSlug}kariermu-${isMobile ? 'webview' : 'web'}`
  const encodedSourceQuery = window.btoa(query)
  return `&source=${encodedSourceQuery}`
}
